import { REQUEST_METHOD } from '@/constants/common';
import { apiInstance } from '@/utils';

export interface AePreparedNotification {
  id: number;
  /**
   * ae_bundle_ready: an AE's prepared work; loop_heads_up: this month's nurture-loop updates (mb-frontend#4458);
   * campaign_step_interrupted / campaign_contacts_returned: a campaign step stopped mid-run, and the
   * contacts it had not reached were handed back to the campaign; loop_needs_attention: the rep's loop
   * cannot do its work without them (a disconnected sending address, a mailbox-health pause).
   */
  kind: 'ae_bundle_ready' | 'loop_heads_up' | 'campaign_step_interrupted' | 'campaign_contacts_returned' | 'loop_needs_attention';
  title: string;
  body: string;
  href: string;
  metadata: {
    bundle_id?: string;
    trigger_type?: string;
    brief_id?: number;
    items?: number;
    audience_id?: number;
    execution_id?: number;
    restored_count?: number;
  };
  read_at: string | null;
  created_at: string;
}

export interface AePreparedNotificationsResponse {
  items: AePreparedNotification[];
  unread_count: number;
}

export const getAePreparedNotifications = async (): Promise<AePreparedNotificationsResponse> => {
  const response = await apiInstance({
    method: REQUEST_METHOD.GET,
    url: '/private/notifications',
    params: { limit: 20 },
  });
  return response.data.data as AePreparedNotificationsResponse;
};

export const markAePreparedNotificationRead = async (notificationId: number): Promise<void> => {
  await apiInstance({
    method: REQUEST_METHOD.POST,
    url: `/private/notifications/${notificationId}/read`,
  });
};

export const markAllAePreparedNotificationsRead = async (): Promise<void> => {
  await apiInstance({
    method: REQUEST_METHOD.POST,
    url: '/private/notifications/read-all',
  });
};
